import { Box, Stack, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import type { JSX } from "react";
import { useTranslation } from "react-i18next";

import { EditIcon } from "@/assets/icons/Edit";
import { EyeOutlinedIcon } from "@/assets/icons/EyeOutlinedIcon";
import { MarkerPinIcon } from "@/assets/icons/MarkerPin";

const styles = {
  cardIcon: { fontSize: 20, color: "primary.main" },
};

export const EmptyValuationsList = (): JSX.Element => {
  const { t } = useTranslation("ValuationListPage");

  return (
    <Stack spacing={"10px"} height={"100%"}>
      <Stack spacing={"20px"} textAlign="center" height={"100%"} justifyContent="center">
        <Typography variant="sectionHeader">{t("noValuations")}</Typography>
        <Typography variant="body1">{t("startFirstValuation")}</Typography>
      </Stack>
      <Grid container spacing={3}>
        {/* Card 1 */}
        <Grid size={{ xs: 12, md: 4 }}>
          <Box bgcolor={"#FAFAFA"} p={"20px"} sx={{ height: "100%", width: "100%" }}>
            <Stack spacing={2}>
              <MarkerPinIcon sx={styles.cardIcon} />
              <Stack>
                <Typography variant="pageSubSectionTitle" gutterBottom>
                  {t("captureProperty.title")}
                </Typography>
                <Typography variant="subText">{t("captureProperty.description")}</Typography>
              </Stack>
            </Stack>
          </Box>
        </Grid>

        {/* Card 2 */}
        <Grid size={{ xs: 12, md: 4 }}>
          <Box bgcolor={"#FAFAFA"} p={"20px"} sx={{ height: "100%", width: "100%" }}>
            <Stack spacing={2}>
              <EyeOutlinedIcon sx={styles.cardIcon} />
              <Stack>
                <Typography variant="pageSubSectionTitle" gutterBottom>
                  {t("checkValuation.title")}
                </Typography>
                <Typography variant="subText">{t("checkValuation.description")}</Typography>
              </Stack>
            </Stack>
          </Box>
        </Grid>

        {/* Card 3 */}
        <Grid size={{ xs: 12, md: 4 }}>
          <Box bgcolor={"#FAFAFA"} p={"20px"} sx={{ height: "100%", width: "100%" }}>
            <Stack spacing={2}>
              <EditIcon sx={styles.cardIcon} />
              <Stack>
                <Typography variant="pageSubSectionTitle" gutterBottom>
                  {t("createReport.title")}
                </Typography>
                <Typography variant="subText">{t("createReport.description")}</Typography>
              </Stack>
            </Stack>
          </Box>
        </Grid>
      </Grid>
    </Stack>
  );
};
